import ReportDetail from '@components/common/ReportDetails';
import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { useSingleSurvey } from '@hooks/getQueries';
import usePermission from '@hooks/usePermission';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

export default function SurveyReportDetails() {
  const { id } = useParams();
  const { data: survey } = useSingleSurvey(id);

  const {
    data: { studyPermission },
    isPending,
  } = usePermission({ study: survey });

  return (
    <PageContainer title={'Survey | Reports'}>
      <Suspense fallback={<Spinner isPending={isPending} />}>
        <ErrorBoundary>
          <ReportDetail canEdit={studyPermission?.edit} />
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
